module.exports = {
  "sidebar.app": "Home",
  "sidebar.horizontal": "Horizontal",
  "sidebar.horizontalMenu": "Menu horizontal",
  "sidebar.general": "Geral",
  "sidebar.component": "Componente",
  "sidebar.features": "Recursos",
  "sidebar.applications": "Aplicativos",
  "sidebar.dashboard": "Board",
  "sidebar.whsRecpts": "Recebimento do armazém",
  "sidebar.whsRecpt": "Armazém",
  "sidebar.details": "Detalhes",
  "sidebar.dashboard1": "Quadro 1",
  "sidebar.dashboard2": "Quadro 2",
  "sidebar.dashboard3": "Quadro 3",
  "sidebar.modules": "Módulos",
  "sidebar.agency": "Agência",
  "sidebar.pages": "Páginas",
  "sidebar.gallery": "Galeria",
  "sidebar.pricing": "Preços",
  "sidebar.termsConditions": "Termos e condições",
  "sidebar.feedback": "Feedback",
  "sidebar.report": "Report",
  "sidebar.faq (s)": "Faq (s)",
  "sidebar.advancedComponent": "Componente avançado",
  "sidebar.blank": "Branco",
  "sidebar.session": "Session",
  "sidebar.login": "Log in",
  "sidebar.register": "Registo",
  "sidebar.lockScreen": "Block fabric",
  "sidebar.forgotPassword": "Esqueci minha senha",
  "sidebar.404": "404",
  "sidebar.500": "500",
  "sidebar.uiComponents": "Componentes da interface do usuário",
  "sidebar.alerts": "Alertas",
  "sidebar.appBar": "Appbar",
  "sidebar.avatars": "Avatares",
  "botões laterais": "Botões",
  "sidebar.bottomNavigations": "navigação inferior",
  "sidebar.badges": "Insignias",
  "sidebar.cards": "Cartões",
  "sidebar.cardsMasonry": "Masonary Cards",
  "sidebar.chip": "Chip",
  "sidebar.dialog": "Diálogo",
  "sidebar.dividers": "Divisores",
  "sidebar.drawers": "Drawers",
  "sidebar.popover": "Popover",
  "sidebar.expansionPanel": "Painel de Expansão",
  "sidebar.gridList": "lista de notas",
  "sidebar.list": "List",
  "sidebar.menu": "Menu",
  "sidebar.popoverAndToolTip": "Popover e dica de ferramenta",
  "sidebar.progress": "Progress",
  "sidebar.snackbar": "Snackbar",
  "sidebar.selectionControls": "Seleção Controls",
  "sidebar.advanceUiComponents":
    "Componentes avançados da interface do usuário",
  "sidebar.dateAndTimePicker": "Seletor de dados e tempo",
  "sidebar.tabs": "Tabs",
  "sidebar.stepper": "passo a passo",
  "sidebar.notification": "Notificação",
  "sidebar.sweetAlert": "Sweet Alert",
  "sidebar.autoComplete": "Full auto",
  "sidebar.aboutUs": "About us",
  "sidebar.widgets": "Widgets",
  "sidebar.forms": "Formulários",
  "sidebar.formElements": "Elementos do formulário",
  "sidebar.textField": "campo de texto",
  "sidebar.selectList": "Selecionar lista",
  "sidebar.charts": "Gráficos",
  "sidebar.reCharts": "Re Graphics",
  "sidebar.reactChartjs2": "Reagir Chartjs 2",
  "sidebar.icons": "Ícones",
  "sidebar.themifyIcons": "Themify Icons",
  "sidebar.simpleLineIcons": "Ícones de linha simples",
  "sidebar.materialIcons": "Ícones de material",
  "sidebar.fontAwesome": "Fonte incrível",
  "sidebar.tables": "Tabelas",
  "sidebar.basic": "BASIC",
  "sidebar.dataTable": "Tabela de dados",
  "sidebar.responsive": "Sensitive",
  "sidebar.reactTable": "Reagir",
  "sidebar.maps": "Maps",
  "sidebar.googleMaps": "Google maps",
  "sidebar.leafletMaps": "Mapas de livretos",
  "sidebar.inbox": "Caixa de entrada",
  "sidebar.users": "Usuários",
  "sidebar.userProfile1": "Perfil do usuário 1",
  "sidebar.userProfile2": "Perfil do usuário 2",
  "sidebar.userManagement": "Gerenciamento de usuários",
  "sidebar.userProfile": "Perfil do usuário",
  "sidebar.userList": "Lista de usuários",
  "sidebar.calendar": "Calendário",
  "sidebar.cultures": "Culturas",
  "sidebar.dnd": "Dnd",
  "sidebar.selectable": "Selecionável",
  "sidebar.customRendering": "Representação personalizada",
  "sidebar.chat": "Chat",
  "sidebar.toDo": "O que fazer",
  "sidebar.editor": "Editor",
  "sidebar.wysiwygEditor": "Editor Editor WYSIWYGWYSIWYG",
  "sidebar.quillEditor": "Pen Editor",
  "sidebar.reactAce": "Reagir Ace",
  "sidebar.dragAndDrop": "Arrastar e soltar",
  "sidebar.reactDragula": "Reagir Dragula",
  "sidebar.reactDnd": "Reagir Dnd",
  "sidebar.blogManagement": "Gerenciamento de blogs",
  "sidebar.ecommerce": "Comércio eletrônico",
  "sidebar.shopList": "Lista de compras",
  "sidebar.shopGrid": "Comprar grade",
  "sidebar.invoice": "Fatura",
  "sidebar.multilevel": "Multilevel",
  "sidebar.sublevel": "Sub-level",
  "widgets.totalEarns": "Total de vitórias",
  "widgets.weight": "Peso (Kgs) Enviado",
  "widgets.fob": "Envio FOB ($)",
  "widgets.emailsStatistics": "Estatísticas de e-mail",
  "widgets.totalRevenue": "Receita total",
  "widgets.onlineVisitors": "Votos online",
  "widgets.trafficSources": "Origens de tráfego",
  "widgets.RecentOrders": "pedidos recentes",
  "widgets.topSellings": "Melhores vendas",
  "widgets.productReports": "Relatórios de produtos",
  "widgets.productStats": "Estatísticas do produto",
  "widgets.ComposeEmail": "Escrever e-mail",
  "widgets.employeePayroll": "Employee Payroll",
  "widgets.visitors": "Visitantes",
  "widgets.orders": "Pedidos",
  "widgets.orderStatus": "Status do pedido",
  "widgets.totalSales": "Total de vendas",
  "widgets.netProfit": "Lucro líquido",
  "widgets.overallTrafficStatus": "Estado geral do tráfego",
  "widgets.tax": "Tax",
  "widgets.expenses": "Despesas",
  "widgets.currentTime": "Hora atual",
  "widgets.ratings": "Qualificações",
  "widgets.currentDate": "Data atual",
  "widgets.todayOrders": "Pedidos de hoje",
  "widgets.toDoList": "Para criar listas",
  "widgets.discoverPeople": "Discover people",
  "widgets.comments": "Comentários",
  "widgets.newCustomers": "novos clientes",
  "widgets.recentNotifications": "notificações recentes",
  "widgets.appNotifications": "Notificações de aplicativos",
  "widgets.newEmails": "Novos emails",
  "widgets.siteVisitors": "visitantes do site",
  "widgets.recentActivities": "Atividades recentes",
  "widgets.recentOrders": "pedidos recentes",
  "widgets.gallery": "Galeria",
  "widgets.pricing": "Preços",
  "widgets.enterpriseEdition": "Company Edition",
  "widgets.personalEdition": "Personal Edition",
  "widgets.socialCompanies": "Empresas sociais",
  "widgets.teamEdition": "Team Edition",
  "widgets.standard": "Padrão",
  "widgets.advanced": "Avançado",
  "widgets.master": "MasterDomine",
  "widgets.Mega": "MegaMega",
  "widgets.logIn": "Login",
  "widgets.signUp": "Inscreva-se",
  "widgets.lockScreen": "Bloquear tela",
  "widgets.alertsWithLink": "Alertas com link",
  "widgets.additionalContent": "Conteúdo adicional",
  "widgets.alertDismiss": "Descartar alerta",
  "widgets.uncontrolledDisableAlerts": "Desativando alertas não controlados",
  "widgets.contextualAlerts": "Alertas contextuais",
  "widgets.alertsWithIcons": "Alertas com ícones",
  "widgets.Simple App Bars": "Barras de aplicativos simples",
  "widgets.appBarsWithButtons": "Barras da aplicação com botões",
  "widgets.imageAvatars": "Avatares de imagem",
  "widgets.lettersAvatars": "Cartas de Avatares",
  "widgets.iconsAvatars": "Ícones dos Avatares",
  "widgets.flatButtons": "botões planos",
  "widgets.raisedButton": "botão elevado",
  "widgets.buttonWithIconAndLabel": "Botão com ícone e etiqueta",
  "widgets.floatingActionButtons": "Botões de ação flutuante",
  "widgets.iconButton": "botão ícone",
  "widgets.socialMediaButton": "Botão de mídia social",
  "widgets.reactButton": "Botão Reagir",
  "widgets.buttonOutline": "Esboço do botão",
  "widgets.buttonSize": "Tamanho do botão",
  "widgets.buttonState": "Status do botão",
  "widgets.buttonNavigationWithNoLabel": "Botão de navegação sem etiqueta",
  "widgets.buttonNavigation": "Navegação por botão",
  "widgets.iconNavigation": "Navegação de ícones",
  "widgets.badgeWithHeadings": "Distintivo com títulos",
  "widgets.contextualVariations": "Variações Contextuais",
  "widgets.badgeLinks": "links de placa",
  "widgets.materialBadge": "emblema de material",
  "widgets.simpleCards": "Cartões simples",
  "widgets.backgroundVariant": "Variante de fundo",
  "widgets.cardOutline": "Esquema do cartão",
  "widgets.overlayCard": "Cartão de sobreposição",
  "widgets.cardGroup": "Grupo de cartas",
  "widgets.cardTitle": "Título do cartão",
  "widgets.specialTitleTreatment": "Tratamento do título especial",
  "widgets.chipWithClickEvent": "Chip com evento Click",
  "widgets.chipArray": "Chip Array",
  "widgets.dialogs": "Diálogos",
  "widgets.listDividers": "Listar Divisores",
  "widgets.insetDividers": "Divisores de inserção",
  "widgets.temporaryDrawers": "Gavetas temporárias",
  "widgets.permanentDrawers": "Gavetas permanentes",
  "widgets.simpleExpansionPanel": "Painel de expansão simples",
  "widgets.controlledAccordion": "Accordion controlled",
  "widgets.secondaryHeadingAndColumns": "Subheader e colunas",
  "widgets.imageOnlyGridLists": "Grid lists with only images",
  "widgets.advancedGridLists": "Listas de grade avançadas",
  "widgets.singleLineGridLists": "Listas de grade de linha única",
  "widgets.simpleLists": "listas simples",
  "widgets.folderLists": "Listas de pastas",
  "widgets.listItemWithImage": "Listar item com imagem",
  "widgets.switchLists": "Alterar listas",
  "widgets.insetLists": "listas de inserção",
  "widgets.nestedLists": "Listas aninhadas",
  "widgets.checkboxListControl": "Lista de controle de caixas de seleção",
  "widgets.pinedSubHeader": "Sub header pined",
  "widgets.InteractiveLists": "Listas interativas",
  "widgets.simpleMenus": "Menus simples",
  "widgets.selectedMenu": "Menu Selecionado",
  "widgets.maxHeightMenu": "Menu de altura máxima",
  "widgets.changeTransition": "Alterar a transição",
  "widgets.paper": "Papel",
  "widgets.anchorPlayGround": "Anchor Playground",
  "widgets.tooltip": "Informações sobre ferramentas",
  "widgets.positionedToolTips": "Snack Bar Posicionado",
  "widgets.circularProgressBottomStart":
    "Início mais baixo do progresso circular",
  "widgets.interactiveIntegration": "Integração Interativa",
  "widgets.determinate": "Determinado",
  "widgets.linearProgressLineBar": "Linear Progress Bar Line",
  "widgets.indeterminate": "Indeterminado",
  "widgets.buffer": "Buffer",
  "widgets.query": "Consulta",
  "widgets.transitionControlDirection": "Endereço de controle de transição",
  "widgets.simpleSnackbar": "Snackbar Simples",
  "widgets.positionedSnackbar": "Snack Bar Posicionado",
  "widgets.contextualColoredSnackbars": "Snackbars de cores contextuais",
  "widgets.simpleCheckbox": "Caixa de seleção simples",
  "widgets.indeterminateSelection": "Seleção Interminada",
  "widgets.disabledCheckbox": "Caixa de seleção desabilitada",
  "widgets.customColorCheckbox": "Custom color check box",
  "widgets.VerticalStyleCheckbox": "Caixa de seleção de estilo vertical",
  "widgets.horizontalStyleCheckbox": "Caixa de seleção de estilo horizontal",
  "widgets.radioButtons": "Botões de rádio",
  "widgets.disabledRadio": "Rádio desativado",
  "widgets.withError": "Com erro",
  "widgets.dateAndTimePicker": "Seletor de data e hora",
  "widgets.defaultPicker": "Seletor padrão",
  "widgets.timePicker": "Seletor de horário",
  "widgets.weekPicker": "Seletor de Semana",
  "widgets.defaultDatePicker": "Seletor de data padrão",
  "widgets.customPicker": "Seletor personalizado",
  "widgets.tabs": "Tabs",
  "widgets.fixedTabs": "guias corrigidas",
  "widgets.basicTab": "guia Básico",
  "widgets.wrappedLabels": "Etiquetas encapsuladas",
  "widgets.centeredLabels": "Etiquetas centralizadas",
  "widgets.forcedScrolledButtons": "Botões deslocados forçados",
  "widgets.iconsTabs": "Guias de ícones",
  "widgets.withDisableTabs": "Com desabilitar guias",
  "widgets.iconWithLabel": "Ícone com etiqueta",
  "widgets.stepper": "passo a passo",
  "widgets.horizontalLinear": "Horizontal linear",
  "widgets.horizontalNonLinear": "Horizontal não linear",
  "widgets.horizontalLinerAlternativeLabel":
    "Etiqueta de revestimento alternativa horizontal",
  "widgets.horizontalNonLinerAlternativeLabel":
    "Etiqueta horizontal alternativa sem revestimento",
  "widgets.verticalStepper": "Vertical stepper",
  "widgets.descriptionAlert": "Descrição do alerta",
  "widgets.customIconAlert": "Alerta de ícone personalizado",
  "widgets.withHtmlAlert": "Com o alerta de HTML",
  "widgets.promptAlert": "Aviso rápido",
  "widgets.passwordPromptAlert": "Alerta de solicitação de senha",
  "widgets.customStyleAlert": "Alerta de estilo personalizado",
  "widgets.autoComplete": "Completo auto",
  "widgets.reactSelect": "React Select",
  "widgets.downshiftAutoComplete": "Down Change Auto Complete",
  "widgets.reactAutoSuggests": "React Auto Suggests",
  "widgets.aboutUs": "Sobre nós",
  "widgets.ourVision": "Nossa Visão",
  "widgets.ourMissions": "Nossas Missões",
  "widgets.ourMotivation": "Nossa motivação",
  "widgets.defaultReactForm": "Formulário de declaração de defualt",
  "widgets.url": "Url",
  "widgets.textArea": "Área de texto",
  "widgets.file": "Arquivo",
  "widgets.formGrid": "Grid Form",
  "widgets.inlineForm": "Formulário on-line",
  "widgets.inputSizing": "Tamanho da entrada",
  "widgets.inputGridSizing": "Tamanho da grade de entrada",
  "widgets.hiddenLabels": "Tags ocultas",
  "widgets.formValidation": "Validação de formulário",
  "widgets.number": "Número",
  "widgets.date": "Data",
  "widgets.time": "Tempo",
  "widgets.color": "Cor",
  "widgets.search": "Pesquisar",
  "widgets.selectMultiple": "Selecionar vários",
  "widgets.inputWithSuccess": "Entrada bem sucedida",
  "widgets.inputWithDanger": "Entrada com perigo",
  "widgets.simpleTextField": "campo de texto simples",
  "widgets.component": "Componentes",
  "widgets.layouts": "Designs",
  "widgets.inputAdornments": "Entrada de adoração",
  "widgets.formattedInputs": "Entradas formatadas",
  "widgets.simpleSelect": "Seleção simples",
  "widgets.nativeSelect": "Seleção nativa",
  "widgets.MultiSelectList": "Lista de seleção Mutlti",
  "widgets.lineChart": "Gráfico de linhas",
  "widgets.barChart": "Gráfico de barras",
  "widgets.stackedBarChart": "Gráfico de barras empilhadas",
  "widgets.lineBarAreaChart": "Gráfico de área da barra de linha",
  "widgets.areaChart": "Carta de área",
  "widgets.stackedAreaChart": "Tabela de áreas empilhadas",
  "widgets.verticalChart": "Gráfico vertical",
  "widgets.radarChart": "Gráfico de radar",
  "widgets.doughnut": "Donut",
  "widgets.polarChart": "Gráfico Polar",
  "widgets.pieChart": "gráfico de pizza",
  "widgets.bubbleChart": "Bolha Gráfica",
  "widgets.horizontalBar": "Barra Horizonatl",
  "widgets.basicTable": "Tabela básica",
  "widgets.contextualColoredTable": "Tabela de cores contextuais",
  "widgets.dataTable": "Tabela de dados",
  "widgets.employeeList": "Lista de funcionários",
  "widgets.responsiveTable": "Tabela receptiva",
  "widgets.responsiveFlipTable": "Tabela rotativa receptiva",
  "widgets.reactGridControlledStateMode": "React Grid Revised Status Mode",
  "widgets.googleMaps": "Google maps",
  "widgets.productsReports": "Relatórios de produtos",
  "widgets.taskList": "Lista de tarefas",
  "widgets.basicCalender": "Calendário básico",
  "widgets.culturesCalender": "Calendário de culturas",
  "widgets.dragAndDropCalender": "Arrastar e soltar calendário",
  "widgets.selectableCalender": "Calendário selecionável",
  "widgets.customRendering": "Representação personalizada",
  "widgets.customCalender": "Calendário personalizado",
  "widgets.searchMailList": "Lista de discussão de pesquisa",
  "components.buyNow": "Compre agora",
  "components.choose": "Escolher",
  "components.username": "Username",
  "components.passwords": "Senhas",
  "widgets.forgetPassword": "Senha esquecida",
  "components.signIn": "Register",
  "components.dontHaveAccountSignUp": "Você não possui um registro de conta",
  "components.enterUserName": "Digite seu nome de usuário",
  "components.enterEmailAddress": "Digite o endereço de e-mail",
  "components.confirmPasswords": "Confirmar senhas",
  "components.alreadyHavingAccountSignIn": "Você já tem uma conta Entrar",
  "components.enterYourPassword": "Digite sua senha",
  "components.unlock": "desbloquear",
  "components.enterPasswords": "Inserir senhas",
  "components.resetPassword": "Rescue password",
  "components.pageNotfound": "Página não encontrada",
  "components.goToHomePage": "Ir para a página inicial",
  "components.sorryServerGoesWrong": "Desculpe, o servidor está errado",
  "components.persistentDrawer": "Gaveta persistente",
  "components.back": "Voltar",
  "components.next": "Próximo",
  "components.completeStep": "Concluir passo",
  "components.withHtml": "Com Html",
  "components.prompt": "Rápido",
  "components.withDescription": "Com descrição",
  "components.success": "Sucesso",
  "components.passwordPrompt": "Indicação de senha",
  "components.warning": "Aviso",
  "components.customIcon": "Ícone personalizado",
  "components.customStyle": "Estilo personalizado",
  "components.basic": "BASIC",
  "components.submit": "Enviar",
  "components.compose": "Compor",
  "components.sendMessage": "Enviar mensagem",
  "components.addNewTasks": "Adicionar novas tarefas",
  "components.addToCart": "Adicionar ao carrinho",
  "components.payNow": "Pague agora",
  "components.print": "Impressão",
  "components.cart": "Carro",
  "components.viewCart": "Ver carro",
  "components.checkout": "Verificar",
  "widgets.QuickLinks": "links rápidos",
  "widgets.upgrade": "melhorar",
  "widgets.app": "Aplicativo",
  "widgets.addNew": "Adicionar novo",
  "widgets.orderDate": "Data do pedido",
  "widgets.status": "Estado",
  "widgets.trackingNumber": "O número de rastreamento",
  "widgets.action": "Ação",
  "widgets.designation": "Designação",
  "widgets.subject": "tema",
  "widgets.send": "Enviar",
  "widgets.saveAsDrafts": "Salvar como rascunhos",
  "widgets.onlineSources": "Fontes on-line",
  "widgets.lastMonth": "Último mês",
  "widgets.widgets": "Widgets",
  "widgets.listing": "Lista",
  "widgets.paid": "Pago",
  "widgets.refunded": "Reintegrado",
  "widgets.done": "Feito",
  "widgets.pending": "Pendente",
  "widgets.cancelled": "Cancelado",
  "widgets.approve": "Aprovar",
  "widgets.following": "Seguindo",
  "widgets.follow": "seguir",
  "widgets.graphs & Charts": "Gráficos e gráficos",
  "widgets.open": "Aberto",
  "widgets.bounced": "devolvido",
  "widgets.spam": "Lixo eletrônico",
  "widgets.unset": "Desarmado",
  "widgets.bandwidthUse": "Uso da largura de banda",
  "widgets.dataUse": "Uso de dados",
  "widgets.unsubscribe": "Cancelar assinatura",
  "widgets.profile": "Perfil",
  "widgets.messages": "Mensagens",
  "widgets.support": "Suporte",
  "widgets.faq (s)": "FAQ (s)",
  "widgets.upgradePlains": "Atualizar planícies",
  "widgets.logOut": "Sair",
  "widgets.mail": "Mail",
  "widgets.adminTheme": "tema do administrador",
  "widgets.wordpressTheme": "Tema do Wordpress",
  "widgets.addToCart": "Adicionar ao carrinho",
  "widgets.plan": "Plan",
  "widgets.basic": "BASIC",
  "widgets.pro": "Pro",
  "widgets.startToBasic": "Iniciar básico",
  "widgets.upgradeToPro": "Atualizar para o Pro",
  "widgets.upgradeToAdvance": "Melhorar para avançar",
  "widgets.comparePlans": "Comparar planos",
  "widgets.free": "Grátis",
  "widgets.frequentlyAskedQuestions": "Perguntas frequentes",
  "widgets.searchIdeas": "Pesquisar por ideias",
  "widgets.startDate": "data de início",
  "widgets.endDate": "Data final",
  "widgets.category": "Categoria",
  "widgets.apply": "Aplicar",
  "widgets.downloadPdfReport": "Download do relatório em PDF",
  "widgets.yesterday": "Ontem",
  "widgets.totalOrders": "Total de pedidos",
  "widgets.totalVisitors": "Total de visitantes",
  "widgets.typeYourQuestions": "Escreva suas perguntas",
  "widgets.username": "Username",
  "widgets.password": "Senha",
  "widgets.signIn": "Register",
  "widgets.enterYourPassword": "Digite sua senha",
  "widgets.alreadyHavingAccountLogin": "Você já tem acesso à conta",
  "widgets.composeMail": "Escrever e-mail",
  "widgets.issue": "Problema",
  "widgets.recentChat": "Chat recente",
  "widgets.previousChat": "chat anterior",
  "widgets.all": "Todos",
  "widgets.filters": "Filtros",
  "widgets.deleted": "Excluído",
  "widgets.starred": "Semeada com estrelas",
  "widgets.frontend": "Interface",
  "widgets.backend": "Backend",
  "widgets.api": "Api",
  "widgets.simpleAppBar": "Barra de aplicativos simples",
  "widgets.recents": "Recentes",
  "widgets.cardLink": "Card link",
  "widgets.anotherLink": "Outro link",
  "widgets.cardSubtitle": "cardSubtittle",
  "widgets.confirmationDialogs": "Diálogos de confirmação",
  "widgets.deletableChip": "Deletable chip",
  "widgets.customDeleteIconChip": "Custom delete icon chip",
  "widgets.openAlertDialog": "Abrir caixa de diálogo de alerta",
  "widgets.openResponsiveDialog": "Abrir diálogo receptivo",
  "widgets.openSimpleDialog": "Abrir um diálogo simples",
  "widgets.openFormDialog": "Abrir a caixa de diálogo do formulário",
  "widgets.follower": "Seguidor",
  "widgets.important": "Importante",
  "widgets.private": "Particular",
  "widgets.openLeft": "Abrir para a esquerda",
  "widgets.openRight": "Abrir para a direita",
  "widgets.openTop": "Abrir capa",
  "widgets.openBottom": "Bottom open",
  "widgets.selectTripDestination": "Selecione o destino da viagem",
  "widgets.pinnedSubheaderList": "Lista de subpastas fixas",
  "widgets.singleLineItem": "Item de linha único",
  "widgets.acceptTerms": "Aceite os termos",
  "widgets.optionA": "Opção A",
  "widgets.optionB": "Opção B",
  "widgets.optionC": "Opção C",
  "widgets.optionM": "Opção M",
  "widgets.optionN": "Opção N",
  "widgets.optionO": "Opção O",
  "widgets.customColor": "Cor personalizada",
  "widgets.centeredTabs": "Abas centralizadas",
  "widgets.multipleTabs": "Várias abas",
  "widgets.preventScrolledButtons": "Evitar botões deslocados",
  "widgets.browse": "Glance",
  "widgets.formValidate": "Validar formulário",
  "widgets.code": "Código",
  "widgets.company": "Empresa",
  "widgets.price": "Preço",
  "widgets.change": "Alterar",
  "widgets.high": "High",
  "widgets.low": "Baixo",
  "widgets.volume": "Volume",
  "widgets.personalDetails": "Detalhes pessoais",
  "widgets.occupation": "Ocupação",
  "widgets.companyName": "nome da empresa",
  "widgets.phoneNo": "telefone não",
  "widgets.city": "Cidade",
  "widgets.zipCode": "CEP",
  "widgets.updateProfile": "Atualização de perfil",
  "widgets.reject": "Rejeitar",
  "widgets.exportToExcel": "Exportar para o Excel",
  "widgets.addNewUser": "Adicionar novo usuário",
  "widgets.workWeek": "Semana de trabalho",
  "widgets.agenda": "Agenda",
  "widgets.conference": "Conferência",
  "widgets.dailySales": "Vendas diárias",
  "widgets.today": "Today",
  "widgets.campaignPerformance": "Desempenho da campanha",
  "widgets.supportRequest": "Pedido de suporte",
  "widgets.usersList": "Lista de usuários",
  "widgets.lastWeek": "Última semana",
  "themeOptions.sidebarOverlay": "Sobreposição da barra lateral",
  "themeOptions.sidebarBackgroundImages": "Imagens de fundo da barra lateral",
  "themeOptions.sidebarImage": "Imagem da barra lateral",
  "themeOptions.miniSidebar": "Barra lateral mini",
  "themeOptions.boxLayout": "Design da caixa",
  "themeOptions.rtlLayout": "Layout Rtl",
  "themeOptions.darkMode": "Dark Mode",
  "themeOptions.appSettings": "Configurações do aplicativo",
  "themeOptions.sidebarLight": "Leve",
  "themeOptions.sidebarDark": "Dark",
  "button.cancel": "Cancelar",
  "button.add": "Adicionar",
  "button.update": "Atualizar",
  "button.reply": "Resposta",
  "button.delete": "Excluir",
  "button.yes": "Sim",
  "button.viewAll": "Ver todos",
  "button.like": "Eu gosto",
  "button.assignNow": "Atribuir agora",
  "button.seeInsights": "Visualizar estatísticas",
  "sidebar.dateTimePicker": "Seletor de data e hora",
  "components.summary": "Resumo",
  "hint.whatAreYouLookingFor": "o que você está procurando",
  "components.yesterday": "Ontem",
  "components.last7Days": "últimos 7 dias",
  "components.last1Month": "Último 1 mês",
  "components.last6Month": "Últimos 6 meses",
  "components.spaceUsed": "Espaço usado",
  "components.followers": "Seguidor",
  "components.trending": "Tendência",
  "components.paid": "Pago",
  "components.refunded": "Reembolsado",
  "components.done": "Feito",
  "components.pending": "Pending",
  "components.cancelled": "Canceled",
  "components.approve": "Aprovar",
  "components.week": "Semana",
  "components.month": "Month",
  "components.ano": "Ano",
  "components.today": "Today",
  "component.popularity": "Popularidade",
  "components.email": "Email",
  "components.drafts": "Esboços",
  "components.sent": "Enviado",
  "components.trash": "Lixeira",
  "components.all": "Todos",
  "components.do": "Do",
  "components.title": "Título",
  "components.projectName": "Nome do projeto",
  "components.companyName": "Nome da empresa",
  "components.openAlert": "Abrir alerta",
  "components.slideInAlertDialog": "Diálogo de slides no diálogo",
  "components.openFullScreenDialog": "Abrir caixas de diálogo de tela inteira",
  "components.basicChip": "Chip básico",
  "components.clickableChip": "Chip clicável",
  "components.left": "Esquerda",
  "components.right": "Direita",
  "components.expansionPanel1": "Painel de Expansão 1",
  "components.expansionPanel2": "Painel de Expansão 2",
  "components.generalSetting": "Configuração geral",
  "components.advancedSettings": "Configurações avançadas",
  "components.firstName": "Nome",
  "components.lastName": "Sobrenome",
  "components.occupation": "Ocupação",
  "components.phoneNo": "Phone No",
  "components.address": "Endereço",
  "components.city": "Cidade",
  "components.state": "Estado",
  "components.zipCode": "código postal",
  "components.social Connection": "conexão social",
  "widgets.buyMore": "Compre mais",
  "widgets.trafficChannel": "canal de tráfego",
  "widgets.stockExchange": "Bolsa de valores",
  "widgets.tweets": "Tweets",
  "widgets.ourLocations": "Nossos locais",
  "widgets.sales": "Vendas",
  "widgets.to": "To",
  "widgets.shipTo": "Enviar para",
  "widgets.description": "Descrição",
  "widgets.unitPrice": "Preço unitário",
  "widgets.total": "Total",
  "widgets.note": "Nota",
  "widgets.chipWithAvatar": "Chip com Avatar",
  "widgets.chipWithTextAvatar": "Chip com texto Avatar",
  "widgets.chipWithIconAvatar": "Chip com o ícone Avatar",
  "widgets.customClickableChip": "Chip clicável personalizado",
  "widgets.outlineChip": "Chip de esquema",
  "widgets.disableChip": "Desativar Chip",
  "widgets.alertDialog": "Caixa de diálogo de alerta",
  "widgets.animatedSlideDialogs": "Diálogos de slides animados",
  "widgets.fullScreenDialogs": "caixas de diálogo em tela cheia",
  "widgets.formDialogs": "Diálogos de formulário",
  "widgets.simpleDialogs": "caixas de diálogo simples",
  "widgets.responsiveFullScreen": "Receptivo em tela cheia",
  "widgets.primary": "Diretor da escola",
  "widgets.social": "social",
  "widgets.user": "Usuário",
  "widgets.admin": "Administrador",
  "widgets.permanentDrawer": "gaveta permanente",
  "widgets.persistentDrawer": "Gaveta persistente",
  "widgets.switches": "Switches",
  "widgets.horizontalLinearAlternativeLabel":
    "Etiqueta alternativa horizontal linear",
  "widgets.horizontalNonLinearAlternativeLabel":
    "etiqueta alternativa não linear horizontal",
  "widgets.notifications": "Notificações",
  "widgets.basicAlert": "Alerta Básico",
  "widgets.successAlert": "Alerta de sucesso",
  "widgets.warningAlert": "Alerta de aviso",
  "widgets.reactAutoSuggest": "reagir sugerir automaticamente",
  "widgets.components": "Componentes",
  "widgets.multiSelectList": "Lista de seleção múltipla",
  "widgets.updateYourEmailAddress": "Atualizar seu endereço de e-mail",
  "widgets.selectADefaultAddress": "Selecione um endereço padrão",
  "widgets.activity": "Atividade",
  "widgets.basicCalendar": "Calendário básico",
  "widgets.culturesCalendar": "Calendário de Culturas",
  "widgets.dragAndDropCalendar": "arrastar e soltar calendário",
  "widgets.quillEditor": "Editor de Caneta",
  "widgets.reactDND": "Reagir DND",
  "widgets.dragula": "Dragula",
  "button.acceptTerms": "Aceitar termos",
  "button.reject": "Rejeitar",
  "button.addNew": "Adicionar novo",
  "button.goToCampaign": "Ir para a campanha",
  "button.viewProfile": "Ver perfil",
  "button.sendMessage": "Enviar mensagem",
  "button.saveNow": "Salvar agora",
  "button.pen": "caneta",
  "button.search": "Pesquisar",
  "button.downloadPdfReport": "Baixar o relatório em PDF",
  "button.primary": "Main",
  "button.secondary": "Secundário",
  "button.danger": "Perigo",
  "button.info": "Informação",
  "button.success": "sucesso",
  "button.warning": "Aviso",
  "button.link": "Link",
  "button.smallButton": "Botão pequeno",
  "button.largeButton": "Botão grande",
  "button.blockLevelButton": "Botão de nível de bloco",
  "button.primaryButton": "Botão principal",
  "button.button": "Botão",
  "button.save": "Salvar",
  "button.openMenu": "Abrir menu",
  "button.openWithFadeTransition": "Abrir com o Fade Transition",
  "button.openPopover": "Abrir Popover",
  "button.accept": "Aceitar",
  "button.click": "clique",
  "button.complete": "Completo",
  "button.back": "Voltar",
  "button.next": "Próximo",
  "button.completeStep": "Concluir passo",
  "button.error": "Erro",
  "button.writeNewMessage": "Escrever nova mensagem",
  "button.saveChanges": "Salvar alterações",
  "button.addNewUser": "Adicionar novo usuário",
  "button.more": "Mais",
  "hint.searchMailList": "Pesquisar lista de email",
  "widgets.AcceptOrRejectWithin": "Aceitar ou rejeitar dentro",
  "widgets.quoteOfTheDay": "Compromisso do dia",
  "widgets.updated10Minago": "Atualizado há 10 min",
  "widgets.personalSchedule": "Agenda pessoal",
  "widgets.activeUsers": "Usuários ativos",
  "widgets.totalRequest": "Solicitação total",
  "widgets.new": "Novo",
  "widgets.ShareWithFriends": "Compartilhe com amigos!",
  "widgets.helpToShareText":
    "Ajude-nos a espalhar a palavra compartilhando nosso site com seus amigos e seguidores nas redes sociais!",
  "widgets.thisWeek": "Esta semana",
  "widgets.howWouldYouRateUs": "Como você avaliaria a gente?",
  "widgets.booking": "Reserva",
  "widgets.confirmed": "Confirmado",
  "widgets.monthly": "mensalmente",
  "widgets.weekly": "semanalmente",
  "widgets.target": "Objetivo",
  "widgets.totalActiveUsers": "Total de usuários ativos",
  "sidebar.user": "Usuário",
  "sidebar.miscellaneous": "Diversos",
  "sidebar.promo": "Promoção",
  "themeOptions.themeColor": "Cor do tema",
  "module.inbox": "Caixa de entrada",
  "module.drafts": "Esboços",
  "module.sent": "Enviado",
  "module.trash": "Lixeira",
  "module.spam": "Lixo eletrônico",
  "module.frontend": "Interface",
  "module.backend": "Backend",
  "module.api": "Api",
  "module.issue": "Problema",
  "components.emailPreferences": "Preferências de email",
  "components.myProfile": "Meu perfil",
  "sidebar.gettingStarted": "Iniciando",
  "widgets.deadline": "Prazo final",
  "widgets.team": "Equipe",
  "widgets.projectManagement": "Gerenciamento de projetos",
  "widgets.latestPost": "Último post",
  "widgets.projectTaskManagement": "Gerenciamento de Tarefas do Projeto",
  "widgets.selectProject": "Selecionar projeto",
  "widgets.activityBoard": "Quadro de atividades",
  "widgets.checklist": "Lista de verificação",
  "sidebar.shop": "store",
  "sidebar.cart": "Carro",
  "sidebar.checkout": "Revisão",
  "components.product": "Produto",
  "components.quantity": "Quantidade",
  "components.totalPrice": "Preço total",
  "components.removeProduct": "Excluir produto",
  "components.mobileNumber": "Número de telemóvel",
  "components.address2Optional": "Endereço 2 (Opcional)",
  "components.country": "País",
  "components.zip": "Zipper",
  "components.saveContinue": "Salvar Continuar",
  "components.placeOrder": "Fazer pedido",
  "components.payment": "Pagamento",
  "components.billingAddress": "Endereço de entrega",
  "components.ShippingAddressText":
    "O endereço de entrega é o mesmo que o endereço de faturamento.",
  "components.CartEmptyText": "Seu cesto está vazio!",
  "components.NoItemFound": "Nenhum item encontrado",
  "components.goToShop": "Ir para a loja",
  "components.cardNumber": "Número do cartão",
  "components.expiryDate": "Data de expiração",
  "components.cvv": "CVV",
  "components.nameOnCard": "Nome no cartão",
  "components.confirmPayment": "Confirmar pagamento",
  "sidebar.saas": "SAAS",
  "sidebar.multiLevel": "Multi level",
  "sidebar.level1": "Level 1",
  "sidebar.level2": "Nível 2",
  "sidebar.boxed": "Na caixa",
  "sidebar.news": "Notícias",
  //Warehouse Details
  "whsReceiptDetails.details": "Detalhes",
  "whsReceiptDetails.none": "NONE",
  "whsReceiptDetails.number": "Número",
  "whsReceiptDetails.adhoc": "Adhoc",
  "whsReceiptDetails.cancel": "Cancelar",
  "whsReceiptDetails.warehouse": "Armazém",
  "whsReceiptDetails.created": "Criado",
  "whsReceiptDetails.customer": "Cliente",
  "whsReceiptDetails.shipper": "Remetente",
  "whsReceiptDetails.inboundCarrier": "Portadora de entrada",
  "whsReceiptDetails.invoiceDate": "Data da fatura",
  "whsReceiptDetails.invoiceNumber": "Número da fatura",
  "whsReceiptDetails.blNumber": "Número B / L",
  "whsReceiptDetails.stated": "Corrigido",
  "whsReceiptDetails.actual": "Real",
  "whsReceiptDetails.remarks": "Observações",
  "whsReceiptDetails.palletCount": "Contagem de remo",
  "whsReceiptDetails.cartonCount": "Conta do cartão",
  "whsReceiptDetails.grossKgs": "Brute (KGD)",
  "whsReceiptDetails.grossLbs": "Brute (LBS)",
  "whsReceiptDetails.value": "Valor (USD)",
  "whsReceiptDetails.salesOrder": "Pedidos de venda",
  "whsReceiptDetails.shipSet": "Colecção de barcos",
  "whsReceiptDetails.finalizedBy": "Completed by",
  "whsReceiptDetails.finalizedOn": "Concluído em",
  "whsReceiptDetails.finalize": "Finish",
  "whsReceiptDetails.documents": "Observações de documentos",
  "whsReceiptDetails.unusedPouch": "Saco não utilizado",
  "whsReceiptDetails.temperedPouch": "Saco quente",
  "whsReceiptDetails.missingSignature": "Assinatura ausente",
  "whsReceiptDetails.missingPouch": "Missing the bag",
  "whsReceiptDetails.docIssuesReslv": "Problemas de documentação resolvidos?",
  "whsReceiptDetails.warehouseRM":
    "Itens em falta no recibo do armazém PL (escassez)",
  "whsReceiptDetails.missingDocuments": "Documentos em falta",
  "whsReceiptDetails.packingList": "Lista de embalagem",
  "whsReceiptDetails.sli": "SLI",
  "whsReceiptDetails.pieces": "Pieces",
  "whsReceiptDetails.pieceNumber": "Part number",
  "whsReceiptDetails.pieceType": "Tipo de peça",
  "whsReceiptDetails.length": "Comprimento (in)",
  "whsReceiptDetails.width": "Width (in)",
  "whsReceiptDetails.height": "Altura (in)",
  "whsReceiptDetails.trackingNumbers": "Números de acompanhamento",
  "whsReceiptDetails.shipped": "Enviado",
  "whsReceiptDetails.received": "Recebido",
  "whsReceiptDetails.eta": "ETA",
  "whsReceiptDetails.files": "Arquivos",
  "whsReceiptDetails.name": "Nome",
  "whsReceiptDetails.size": "Size",
  "whsReceiptDetails.download": "Download",
  "whsReceiptDetails.emptyFileList": "Nenhum arquivo!",
  "whsReceiptDetails.save": "Salvar",
  "whsReceiptDetails.edit": "Editar",
  "whsReceiptDetails.lin": "LIN",
  "whsReceiptDetails.partNumber": "Part number",
  "whsReceiptDetails.overage": "Excesso",
  "whsReceiptDetails.shortage": "Escassez",
  "whsReceiptDetails.damaged": "Damaged",
  "whsReceiptDetails.carton": "Caixa de cartão",
  "whsReceiptDetails.pallet": "Palette",
  "whsReceiptDetails.pieceCount": "Número de peças",
  "whsReceiptDetails.emptyTracking": "Nenhum rastreamento disponível",
  "whsReceiptDetails.carrier": "Transportadora",
  "whsReceiptDetails.emptyCosts": "N / A",
  "whsReceiptDetails.total": "Total",
  "whsReceiptDetails.notFinalized": "Não finalizado",
  "whsReceiptDetails.customerPO": "PO do cliente",
  "whsReceiptDetails.costs": "Custo"
};
